import update from 'immutability-helper'
import qs from 'qs'
import { filterNewGalleryPhotos, getValueFromObject, handlePhotosQS } from '../Functions'
import toggleModal from './toggleModal'
import { useEffect } from 'react'

const handleClick = ({
  location = '',
  setState,
  state,
  varNames
}) => {
  let newCategory = ''
  if (location !== '') {
    const title = location.slugToUpperCaseWords()
    newCategory = title
    window.history.pushState('', 'Photos: ' + title, '/photo-gallery/' + location + '/')
  } else {
    window.history.pushState('', 'Photos', '/photo-gallery/')
  }

  filterNewGalleryPhotos({
    state: update(state, {
      [`${varNames.academyTimeframe}`]: { $set: '' },
      [`${varNames.category}`]: { $set: newCategory },
      [`${varNames.classmates}`]: { $set: '' },
      [`${varNames.companies}`]: { $set: '' },
      [`${varNames.decade}`]: { $set: '' },
      [`${varNames.page}`]: { $set: 1 },
      [`${varNames.service}`]: { $set: '' },
      [`${varNames.serviceBranch}`]: { $set: '' },
      [`${varNames.subsection}`]: { $set: '' },
      [`${varNames.year}`]: { $set: '' }
    }),
    setState: (state) => setState(state),
    varNames
  })
}

const handlePageClick = ({
  inFooter,
  newPage,
  setState,
  state,
  varNames
}) => {
  let pageLocation = '/photo-gallery/'

  if (state[`${varNames.category}`] !== '') {
    const location = state[`${varNames.category}`].split(' ').join('-').toLowerCase()
    setState(update(state, { page: { $set: newPage } }))
    pageLocation += location + ((newPage !== 1) ? ('/page/' + newPage) : '') + '/'
  } else {
    setState(update(state, { page: { $set: newPage } }))

    pageLocation += ((newPage !== 1) ? ('page/' + newPage + '/') : '')
  }
  window.history.pushState(state, '', pageLocation)
  window.location.hash = qs.stringify(handlePhotosQS({ state, varNames }))
}

const handlePushHistory = ({
  category,
  state
}) => {
  const newImageCategory = getValueFromObject(category)
  let urlLocation = ''
  if (category) {
    urlLocation = newImageCategory.split(' ').join('-').toLowerCase() + '/'
  }
  const newLocation = '/photo-gallery/' + urlLocation

  console.log('History Length: ', window.history.length)
  console.log(newLocation)
  window.history.pushState(
    state,
    null,
    newLocation
  )
}

const handleToggleModal = (key, photos) => toggleModal(key, photos)

export {
  handleClick,
  handlePageClick,
  handlePushHistory,
  handleToggleModal
}
